// Creates the analytics.js client which will be available at window.ga
const makeClient = () => {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments)
    }
    i[r].l = 1 * new Date();
    a = s.createElement(o)
    m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
}

class GoogleAnalytics {

  constructor(account) {
    if (typeof account !== 'string') console.warn(`provided account '${account}' for GoogleAnalytics is not valid`)
    this.account = account
    makeClient()
  }

  initialize = () => {
    window.ga('create', this.account, 'auto', 'tracker');
  }

  pageView = path => {
    window.ga('send', 'pageview', path);
  }

  exception = ({
    description,
    fatal
  }) => {
    window.ga('send', 'exception', {
      'exDescription': description,
      'exFatal': fatal
    });
  }

  event = data => {

    const {
      category,
      action,
      label,
      value,
    } = data

    const fieldsObject = {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
    }

    window.ga('send', fieldsObject)

  }

}

export default GoogleAnalytics